/* notched-slider v0.0.4, @license ISC */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.notchedSlider = factory());
})(this, (function () { 'use strict';

    const supportsSelector = selector => {
      const style = document.createElement("style");
      document.head.appendChild(style);

      try {
        style.sheet.insertRule(selector + "{}", 0);
      } catch (e) {
        return false;
      } finally {
        document.head.removeChild(style);
      }

      return true;
    };

    const notchedSlider = (selector, notchData) => {
      var _a;

      const node = document.querySelector(selector);

      if (node === null) {
        console.warn(`${selector} does not match any document element.`);
        return;
      }

      node.classList.add("notched-slider");
      node.style.setProperty("--span", `${notchData.length * 2 - 1}`);
      [["max", "1"], ["min", "0"], ["step", `any`]].forEach(([option, value]) => node === null || node === void 0 ? void 0 : node.setAttribute(option, value));
      const parent = document.createElement("div");
      (_a = node.parentElement) === null || _a === void 0 ? void 0 : _a.appendChild(parent);
      parent.appendChild(node);
      parent.classList.add("notched-slider-container");
      parent.style.setProperty("--columns", `${notchData.length * 2 + 1}`);
      const notches = [];
      notchData.forEach((_, index) => {
        const span = document.createElement("span");
        span.classList.add("notched-notch");
        span.style.setProperty("--start", `${index * 2 + 1}`);
        parent.prepend(span);
        notches.push(span);
      });
      notchData.forEach((data, index) => {
        const subtitle = document.createElement("div");
        subtitle.classList.add("notched-subtitle");
        subtitle.style.setProperty("--start", `${index * 2 + 1}`);
        data.forEach((string, index) => {
          const span = document.createElement("span");
          span.innerText = string;
          span.classList.add(`notched-subtitle-${index + 1}`);
          subtitle.appendChild(span);
        });
        parent.appendChild(subtitle);
      });

      const colourNotches = () => {
        notches.forEach((item, index) => {
          if (node.valueAsNumber >= index / (notches.length - 1)) item.classList.add("notched-notch-passed");else item.classList.remove("notched-notch-passed");
        });
      };

      if ([`::-moz-range-progress`, `::-ms-fill-lower`].some(style => supportsSelector(style))) {
        node.oninput = () => colourNotches();

        colourNotches();
      }
    };

    return notchedSlider;

}));
//# sourceMappingURL=notched-slider.js.map
